export default __webpack_public_path__ + "static/media/Logo.199542a7.png";